import React from 'react';
import PropTypes from 'prop-types';
import { setPageTitle } from 'utils';
import { I18NConsumer } from './I18N';

const NotFound = ({ orgName, titleCode, messageCode }) => (
  <I18NConsumer>
    {(i18n) => {
      const defaultPageTitle = orgName ? `${orgName} - ${i18n.get('error.404.label')}` : i18n.get('error.404.label');
      setPageTitle(titleCode ? i18n[titleCode] : defaultPageTitle);

      return (
        <div class="offset-sm-1 col-sm-11">
        <div className="error-page error-401">
          <p className="title">
            {i18n[messageCode] || i18n['error.404.title']}
          </p>
          <strong><p className="help-block">
            {i18n['error.404.message3']}
          </p></strong>
          <p className="help-block">
            {i18n['ssp.member.portal.error.page.contact.tip']}
          </p>
          </div>
        </div>
      );
    }}
  </I18NConsumer>
);

NotFound.propTypes = {
  orgName: PropTypes.string,
  titleCode: PropTypes.string,
  messageCode: PropTypes.string,
};

NotFound.defaultProps = {
  orgName: '',
  titleCode: '',
  messageCode: '',
};

export default NotFound;
